/* Miphoria Journal — interactions for `mag-*` sections.
   Every feature is idempotent per element so it survives theme-editor section reloads. */
(function () {
  'use strict';
  // Every mag-* section renders the script tag; only the first copy should run.
  if (window.__magJournal) return;
  window.__magJournal = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function once(el, key) {
    if (el.dataset[key]) return false;
    el.dataset[key] = '1';
    return true;
  }

  /* ---------- Reveal + count-up + bars ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      if (e.target.hasAttribute('data-mag-count')) countUp(e.target);
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }) : null;

  function countUp(el) {
    var raw = el.getAttribute('data-mag-count');
    var target = parseFloat(raw);
    var decimals = (raw.split('.')[1] || '').length;
    if (isNaN(target) || reduce) { el.textContent = raw; return; }
    var start = null, dur = 1600;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * eased).toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initReveal(root) {
    root.querySelectorAll('.mag [data-reveal], .mag [data-mag-count], .mag .mag-bars, .mag .mag-tl__item').forEach(function (el) {
      if (!once(el, 'magObs')) return;
      if (io) io.observe(el); else { el.classList.add('is-in'); if (el.hasAttribute('data-mag-count')) el.textContent = el.getAttribute('data-mag-count'); }
    });
  }

  /* ---------- Reading progress, TOC, parallax, timeline rail (one scroll loop) ---------- */
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var bar = document.querySelector('.mag-progress__bar');
      var body = document.querySelector('[data-mag-article]');
      if (bar && body) {
        var r = body.getBoundingClientRect();
        var total = r.height - window.innerHeight * 0.6;
        var p = Math.max(0, Math.min(1, -r.top / (total > 0 ? total : 1)));
        bar.style.transform = 'scaleX(' + p + ')';
      }
      if (!reduce) {
        document.querySelectorAll('[data-parallax]').forEach(function (m) {
          var rect = m.parentElement.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top > window.innerHeight) return;
          m.style.transform = 'translate3d(0,' + (rect.top * -0.18).toFixed(1) + 'px,0)';
        });
      }
      document.querySelectorAll('.mag-tl').forEach(function (tl) {
        var fill = tl.querySelector('.mag-tl__rail span');
        if (!fill) return;
        var rect = tl.getBoundingClientRect();
        var p = Math.max(0, Math.min(1, (window.innerHeight * 0.6 - rect.top) / rect.height));
        fill.style.height = (p * 100) + '%';
      });
      updateToc();
    });
  }

  var tocLinks = [], tocTargets = [];
  function initToc(root) {
    var prose = root.querySelector('[data-mag-prose]');
    var lists = root.querySelectorAll('[data-mag-toc]');
    if (!prose || !lists.length) return;
    var heads = Array.prototype.filter.call(prose.querySelectorAll('h2'), function (h) { return h.textContent.trim().length > 0; });
    if (heads.length < 2) {
      root.querySelectorAll('.mag-toc').forEach(function (t) { t.hidden = true; });
      return;
    }
    var html = '';
    heads.forEach(function (h, i) {
      if (!h.id) h.id = 'mag-' + (h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') || 'section-' + i);
      html += '<li><a href="#' + h.id + '">' + h.textContent.trim().replace(/</g, '&lt;') + '</a></li>';
    });
    lists.forEach(function (ol) { ol.innerHTML = html; });
    tocTargets = heads;
    tocLinks = Array.prototype.slice.call(root.querySelectorAll('[data-mag-toc] a'));
    tocLinks.forEach(function (a) {
      a.addEventListener('click', function () {
        var d = a.closest('details'); if (d) d.open = false;
      });
    });
  }
  function updateToc() {
    if (!tocTargets.length) return;
    var current = null;
    tocTargets.forEach(function (h) { if (h.getBoundingClientRect().top < 160) current = h.id; });
    tocLinks.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href') === '#' + current); });
  }

  /* ---------- Share: copy link + native share ---------- */
  function initShare(root) {
    root.querySelectorAll('[data-mag-copy]').forEach(function (btn) {
      if (!once(btn, 'magBound')) return;
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-mag-copy');
        var done = function () {
          var msg = btn.parentElement.querySelector('.mag-share__copied');
          if (msg) { msg.classList.add('is-on'); setTimeout(function () { msg.classList.remove('is-on'); }, 1800); }
        };
        if (navigator.share && window.matchMedia('(pointer: coarse)').matches) {
          navigator.share({ title: document.title, url: url }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(done);
        }
      });
    });
  }

  /* ---------- Horizontal rails with arrow buttons ---------- */
  function initRails(root) {
    root.querySelectorAll('[data-mag-rail]').forEach(function (wrap) {
      if (!once(wrap, 'magBound')) return;
      var track = wrap.querySelector('[data-mag-track]');
      if (!track) return;
      wrap.querySelectorAll('[data-mag-dir]').forEach(function (b) {
        b.addEventListener('click', function () {
          var dir = parseInt(b.getAttribute('data-mag-dir'), 10);
          track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
        });
      });
    });
  }

  /* ---------- Comparison table: mobile column tabs ---------- */
  function initCompare(root) {
    root.querySelectorAll('.mag-compare').forEach(function (c) {
      if (!once(c, 'magBound')) return;
      c.querySelectorAll('[data-mag-tab]').forEach(function (t) {
        t.addEventListener('click', function () {
          c.setAttribute('data-active', t.getAttribute('data-mag-tab'));
          c.querySelectorAll('[data-mag-tab]').forEach(function (o) {
            o.classList.toggle('is-active', o === t);
            o.setAttribute('aria-pressed', o === t ? 'true' : 'false');
          });
        });
      });
    });
  }

  /* ---------- Hotspots ---------- */
  function initHotspots(root) {
    root.querySelectorAll('.mag-hot').forEach(function (h) {
      if (!once(h, 'magBound')) return;
      function activate(i) {
        h.querySelectorAll('[data-mag-spot]').forEach(function (el) {
          var on = el.getAttribute('data-mag-spot') === i;
          el.classList.toggle('is-active', on);
          if (el.tagName === 'BUTTON') el.setAttribute('aria-expanded', on ? 'true' : 'false');
        });
      }
      h.querySelectorAll('button[data-mag-spot], .mag-hot__item button').forEach(function (b) {
        b.addEventListener('click', function () {
          activate(b.getAttribute('data-mag-spot') || b.closest('[data-mag-spot]').getAttribute('data-mag-spot'));
        });
      });
      activate('1');
    });
  }

  /* ---------- Before / after ---------- */
  function initBeforeAfter(root) {
    root.querySelectorAll('.mag-ba').forEach(function (ba) {
      if (!once(ba, 'magBound')) return;
      var input = ba.querySelector('input[type=range]');
      if (!input) return;
      var set = function () { ba.style.setProperty('--pos', input.value + '%'); };
      input.addEventListener('input', set);
      set();
    });
  }

  /* ---------- Flip cards ---------- */
  function initFlip(root) {
    root.querySelectorAll('.mag-flip').forEach(function (f) {
      if (!once(f, 'magBound')) return;
      f.addEventListener('click', function () {
        f.classList.toggle('is-flipped');
        f.setAttribute('aria-pressed', f.classList.contains('is-flipped') ? 'true' : 'false');
      });
    });
  }

  /* ---------- Blog index: tag filter ----------
     Filters in place only when every story is on this page (data-mag-local).
     Otherwise the chips are plain links to Shopify's /tagged/ pages. */
  function initFilters(root) {
    root.querySelectorAll('[data-mag-filters]').forEach(function (bar) {
      if (!once(bar, 'magBound')) return;
      var scope = document.getElementById(bar.getAttribute('data-mag-filters'));
      if (!scope || !bar.hasAttribute('data-mag-local')) return;
      var feed = scope.querySelector('.mag-feed');
      var cover = scope.querySelector('.mag-coverstory');
      var empty = scope.querySelector('.mag-empty');

      function apply(tag) {
        var all = tag === '*';
        var shown = 0;
        scope.querySelectorAll('.mag-feed [data-tags]').forEach(function (item) {
          var match = all || item.getAttribute('data-tags').indexOf('|' + tag + '|') > -1;
          item.hidden = !match;
          if (match) { shown++; item.classList.add('is-in'); }
        });
        // The cover story joins the filtered grid so nothing disappears unexpectedly.
        if (cover) {
          var coverMatch = all || cover.getAttribute('data-tags').indexOf('|' + tag + '|') > -1;
          cover.hidden = !all;
          var clone = feed.querySelector('[data-mag-cover-clone]');
          if (clone) clone.hidden = all || !coverMatch;
          if (!all && coverMatch) shown++;
        }
        feed.classList.toggle('is-filtered', !all);
        feed.querySelectorAll('.mag-feed__interlude').forEach(function (i) { i.hidden = !all; });
        if (empty) empty.hidden = shown > 0;
        bar.querySelectorAll('[data-mag-filter]').forEach(function (c) {
          var on = c.getAttribute('data-mag-filter') === tag;
          c.classList.toggle('is-active', on);
          if (on) c.setAttribute('aria-current', 'true'); else c.removeAttribute('aria-current');
          if (on && c.scrollIntoView) bar.scrollTo({ left: c.offsetLeft - bar.clientWidth / 2 + c.clientWidth / 2, behavior: reduce ? 'auto' : 'smooth' });
        });
      }

      bar.querySelectorAll('[data-mag-filter]').forEach(function (chip) {
        chip.addEventListener('click', function (e) {
          e.preventDefault();
          apply(chip.getAttribute('data-mag-filter'));
        });
      });
    });
  }

  function init(root) {
    root = root || document;
    initReveal(root);
    initToc(document);
    initShare(root);
    initRails(root);
    initCompare(root);
    initHotspots(root);
    initBeforeAfter(root);
    initFlip(root);
    initFilters(root);
    onScroll();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
